import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-207be8a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header flex justify-between items-center" }
const _hoisted_2 = { class: "font-bold text-2xl" }
const _hoisted_3 = { class: "w-full xl:w-12/12 mt-3 mx-auto grid grid-rows-1 xl:grid-cols-3" }
const _hoisted_4 = { class: "xl:col-span-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-semibold" }, "Items", -1))
const _hoisted_6 = { class: "unfulfilled" }
const _hoisted_7 = { class: "flex gap-3" }
const _hoisted_8 = { class: "w-24" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = { class: "font-semibold mb-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "quantity-refund" }
const _hoisted_14 = { class: "flex gap-1" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Cannot be refunded ")
const _hoisted_16 = { class: "number top-9" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-semibold" }, "Refund shipping", -1))
const _hoisted_18 = { class: "my-2" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Shipping: ")
const _hoisted_20 = { class: "font-semibold" }
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = { class: "my-2" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Discount: ")
const _hoisted_24 = { class: "font-semibold" }
const _hoisted_25 = { class: "flex flex-col" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-semibold mb-3" }, "Reason for refund", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Your customer won't see this.", -1))
const _hoisted_28 = { class: "col-span-1 mt-4 xl:mt-0 xl:ml-4" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-base font-semibold mb-1" }, "Summary", -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "detail" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Items subtotal", -1))
const _hoisted_34 = { class: "detail" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Shipping", -1))
const _hoisted_36 = { class: "detail" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Discount", -1))
const _hoisted_38 = { class: "detail" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Refund amount", -1))
const _hoisted_40 = { class: "border-t border-gray-200 mt-3 pt-3" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-semibold" }, "REFUND AMOUNT", -1))
const _hoisted_42 = { class: "border-t border-gray-200 mt-3 pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps($setup.content, {
    backPageTitle: `Back`,
    style: {"overflow":"hidden"}
  }), {
    default: _withCtx(() => [
      _createVNode(_component_el_col, { span: 24 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, " Refund order - " + _toDisplayString($setup.data.orderName), 1)
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_card, null, {
            header: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _createElementVNode("section", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.listItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item._id,
                    class: "unfulfilled-items"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          src: item.imageSrc,
                          alt: "",
                          class: "w-20 h-20 object-cover rounded"
                        }, null, 8, _hoisted_9)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("p", _hoisted_11, _toDisplayString(item.itemName), 1),
                        _createElementVNode("p", null, "Price: " + _toDisplayString($setup.formatterDollars(item.price)), 1),
                        _createElementVNode("p", null, "SKU: " + _toDisplayString(item.sku), 1),
                        _createElementVNode("p", null, "Variant: " + _toDisplayString(item.variantTitle), 1),
                        (item.catalogCode)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Catalog code: " + _toDisplayString(item.catalogCode), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        (!item.refundable)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: "danger",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_15
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", null, [
                          (item.refundStatus)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 0,
                                type: 
                        item.refundStatus === 'partially_refunded'
                          ? 'warning'
                          : 'danger'
                      ,
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.refundStatus), 1)
                                ]),
                                _: 2
                              }, 1032, ["type"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_el_tag, {
                          type: $setup.getOrderStatusColor(item.status),
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.status), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _createVNode(_component_el_input_number, {
                        modelValue: item.refundQty,
                        "onUpdate:modelValue": ($event: any) => ((item.refundQty) = $event),
                        min: "0",
                        max: item.quantity,
                        disabled: !item.refundable || item.fullRefunded,
                        "controls-position": "right",
                        class: "w-full min-w-[112px]"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "disabled"]),
                      _createElementVNode("span", _hoisted_16, "/ " + _toDisplayString(item.quantity), 1),
                      _createElementVNode("span", null, _toDisplayString($setup.formatterDollars(item.refundQty * item.price)), 1)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_card, { class: "my-4 pb-2" }, {
            default: _withCtx(() => [
              _hoisted_17,
              _createElementVNode("p", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("span", _hoisted_20, _toDisplayString($setup.data.shippingTitle) + " (" + _toDisplayString($setup.formatterDollars($setup.data.shippingTotal)) + ") ", 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_el_input_number, {
                  modelValue: $setup.refundShipping,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.refundShipping) = $event)),
                  min: "0",
                  max: $setup.data.shippingTotal,
                  step: $setup.data.shippingTotal,
                  "controls-position": "right",
                  class: "w-full"
                }, null, 8, ["modelValue", "max", "step"])
              ]),
              _createElementVNode("p", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("span", _hoisted_24, " Total Discount (" + _toDisplayString($setup.formatterDollars($setup.data.totalDiscount)) + ") ", 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_el_input_number, {
                  modelValue: $setup.totalDiscount,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.totalDiscount) = $event)),
                  min: "0",
                  max: $setup.data.totalDiscount,
                  step: $setup.data.totalDiscount,
                  "controls-position": "right",
                  class: "w-full"
                }, null, 8, ["modelValue", "max", "step"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_card, { class: "pb-3" }, {
            default: _withCtx(() => [
              _hoisted_26,
              _createVNode(_component_el_input, {
                class: "mb-2",
                modelValue: $setup.reason,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.reason) = $event)),
                placeholder: "Enter reason"
              }, null, 8, ["modelValue"]),
              _hoisted_27
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_el_card, null, {
            default: _withCtx(() => [
              _hoisted_29,
              ($setup.refundProvisional == 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_30, "No items selected."))
                : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", null, [
                        _hoisted_33,
                        _createElementVNode("p", null, _toDisplayString($setup.totalQuantity) + " items", 1)
                      ]),
                      _createElementVNode("p", null, _toDisplayString($setup.formatterDollars($setup.subtotal)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("p", null, "+ " + _toDisplayString($setup.formatterDollars($setup.refundShipping)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("p", null, "- " + _toDisplayString($setup.formatterDollars($setup.totalDiscount)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("p", null, _toDisplayString($setup.formatterDollars($setup.refundProvisional)), 1)
                    ])
                  ])),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createVNode(_component_el_input_number, {
                  modelValue: $setup.refundAmount,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.refundAmount) = $event)),
                  class: "mb-2",
                  "controls-position": "right",
                  min: "0",
                  max: $setup.availableRefund
                }, null, 8, ["modelValue", "max"]),
                _createElementVNode("b", null, _toDisplayString($setup.formatterDollars($setup.availableRefund)) + " available for refund", 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_el_button, {
                  class: "refund-btn my-2",
                  type: "primary",
                  disabled: !$setup.refundAmount,
                  onClick: $setup.submit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Refund " + _toDisplayString($setup.formatterDollars($setup.refundAmount)), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 16))
}